module.exports = __webpack_public_path__ + "static/cases-tile-1-4-a90788652c572b2874bc87e1385eb3d5.png";